var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickWobbly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    stroke: "#FFE361",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.50003 13.464L4.70003 15.029L4.95803 16.975C5.10028 18.0529 5.94583 18.9026 7.02303 19.05L8.97503 19.31L10.537 20.5C11.4018 21.1612 12.6023 21.1612 13.467 20.5L15.031 19.306L16.979 19.048C18.0591 18.9045 18.909 18.055 19.053 16.975L19.313 15.023L20.513 13.46C21.1732 12.5957 21.1732 11.3964 20.513 10.532L19.313 8.96703L19.055 7.02103C18.91 5.94117 18.0592 5.0925 16.979 4.95003L15.027 4.69003L13.465 3.50003C12.6003 2.83886 11.3998 2.83886 10.535 3.50003L8.97103 4.69003L7.02303 4.94803C5.94374 5.09237 5.09485 5.94167 4.95103 7.02103L4.69103 8.97303L3.50003 10.536C2.83918 11.4002 2.83918 12.5999 3.50003 13.464Z",
    stroke: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.7939L11.456 14L16 10",
    strokeWidth: 1.05139,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickWobbly);
export default __webpack_public_path__ + "static/media/tickWobbly.032bb59aa020e9866bf94ad3e0fc0094.svg";
export { ForwardRef as ReactComponent };